import { jsx as _jsx } from "react/jsx-runtime";
export var CustomWeekEvent = function (_a) {
    var event = _a.event;
    return (_jsx("div", { className: "custom-week-event-content", dangerouslySetInnerHTML: { __html: event.title }, title: event.title }));
};
